import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'code',
  name: 'Code',
  category: 'utilities',
  description: 'Execute custom JavaScript or Python code',
  icon: 'Code',
  color: 'slate',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  
  // Tool-capable configuration for AI Agent
  toolCapable: {
    enabled: true,
    name: 'execute_code',
    description: 'Execute custom JavaScript or Python code to process data, perform calculations, or transform information. The code has access to input data and can return any valid JSON value.',
    allowManualDescription: true, // Allow users to customize the description for specific use cases
    parameters: {
      code: {
        toolParamName: 'code',
        description: 'Code to execute. The code should return a value. Available variables: items (input data), input (raw input)',
        required: true,
        type: 'string'
      },
      language: {
        toolParamName: 'language',
        description: 'Programming language ("javascript" or "python")',
        required: false,
        type: 'string'
      }
    },
    outputMapping: {
      result: 'The return value from the executed code',
      executionTime: 'Time taken to execute the code in milliseconds'
    }
  }
};

export default definition;
